<template>
  <nav>
    <v-menu
      data-testid="support-icon"
      offset-y
      flat
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              rounded
              data-testid="support-button"
              elevation="0"
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon>mdi-help-circle-outline</v-icon>                    
            </v-btn>
          </template>
          <span>{{ $t('support') }}</span>
        </v-tooltip>
      </template>
      <v-list data-testid="menu-list">
        <v-list-item
          data-testid="list-item-academy"
          target="_blank"
          href="https://skillboost.io/kom-igang/"
        >
          <v-list-item-title class="pr-2">
            {{ $t('tutorialsLiveChat') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </nav>
</template>

<script>

export default {
    data(){
        return{
            first_name: localStorage.user ? JSON.parse(localStorage.user).first_name : '',
            last_name: localStorage.user ? JSON.parse(localStorage.user).last_name : '',
            avatar: localStorage.user ? JSON.parse(localStorage.user).avatar_thumb : null,
            userId: window.$cookies.get('id'),
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            loadingData: false,
            email: localStorage.user ? JSON.parse(localStorage.user).email : '',
            language: localStorage.user ? JSON.parse(localStorage.user).language : '',
            site_url: window.location.origin,
            costumer_name:localStorage.space ? JSON.parse(localStorage.space).subdomain : '',
        }
    },
    methods:{
        
    }
}
</script>